var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup112(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 26.977,
    viewBox: "0 0 48 26.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(-40 -25.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_38",
    "data-name": "Union 38",
    d: "M30.814,25.951A3.424,3.424,0,0,1,29.8,23.464V10.8a4.445,4.445,0,0,0-1.014-3.264,3.737,3.737,0,0,0-2.748-1,3.78,3.78,0,0,0-2.913,1.2,4.5,4.5,0,0,0-1.164,3.235v12.49a3.553,3.553,0,0,1-6.027,2.487,3.424,3.424,0,0,1-1.012-2.487V10.8a4.445,4.445,0,0,0-1.014-3.264,3.737,3.737,0,0,0-2.748-1A3.849,3.849,0,0,0,8.219,7.745a4.451,4.451,0,0,0-1.18,3.229v12.49a3.463,3.463,0,0,1-.974,2.471,3.453,3.453,0,0,1-2.545,1.019,3.482,3.482,0,0,1-2.509-1A3.424,3.424,0,0,1,0,23.464V3.755A3.4,3.4,0,0,1,1.028,1.23,3.527,3.527,0,0,1,3.521.265a3.5,3.5,0,0,1,2.529.981,3.454,3.454,0,0,1,.328.376A9.98,9.98,0,0,1,8.105.732,10.61,10.61,0,0,1,12.055,0,9.326,9.326,0,0,1,19.186,2.84,10.435,10.435,0,0,1,21.9,1.047,11.886,11.886,0,0,1,26.934,0a9.571,9.571,0,0,1,7.147,2.857c1.832,1.885,2.761,4.555,2.761,7.941V23.464a3.553,3.553,0,0,1-6.027,2.487Z",
    transform: "translate(40 25.023)",
    fill: "#042b6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(79 43)",
    fill: "#f9be00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup112);
export default __webpack_public_path__ + "static/media/Group112.c33ec6ecda72da2b1250a8a173657f80.svg";
export { ForwardRef as ReactComponent };